import { seoSections } from "@/mocks/categories";

export default function SafetySection() {
  const { safety } = seoSections;

  return (
    <section className="w-full px-6 md:px-10 py-16 md:py-20">
      <div className="max-w-5xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          <div>
            <span className="inline-block px-4 py-1.5 text-xs font-medium text-foreground-600 bg-background-200/60 rounded-full mb-5">
              Segurança
            </span>
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 mb-8">
              {safety.title}
            </h2>
            <div className="space-y-5">
              {safety.points.map((point, idx) => (
                <div key={idx} className="flex gap-4">
                  <div className="w-6 h-6 rounded-full bg-accent-100 flex-shrink-0 flex items-center justify-center mt-0.5">
                    <i className="ri-shield-check-line text-accent-600 text-sm"></i>
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed">{point}</p>
                </div>
              ))}
            </div>
          </div>
          <div className="relative">
            <img
              src="https://readdy.ai/api/search-image?query=Minimalist%20still%20life%20photography%20of%20laptop%20displaying%20secure%20shopping%20dashboard%20with%20padlock%20icon%20on%20screen%2C%20ceramic%20coffee%20cup%20and%20small%20succulent%20plant%20on%20warm%20cream%20desk%20surface%2C%20soft%20natural%20window%20light%2C%20warm%20neutral%20beige%20tones%2C%20editorial%20tech%20lifestyle%2C%20clean%20modern%20composition%2C%20calm%20productive%20workspace&width=800&height=1000&seq=hb-safety-v2-secure&orientation=portrait"
              alt="Hoobuy Segurança"
              title="Hoobuy Spreadsheet Segurança"
              className="w-full rounded-2xl object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
}